import buildTheme from "./buildTheme";

const darkTheme = buildTheme('dark');

export default darkTheme;
